module.exports = __webpack_public_path__ + "static/media/kzFlagRibbon.2a7c0e4f.png";